/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaModal/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import TysiaModalBackdrop from './TysiaModalBackdrop/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaModal({
  children,
  viewPath = "/DesignSystem/TysiaModal",
  dangerouslyBypassFocusLock,
  height,
  maxWidth = "auto",
  width = 740,
  size,
  onClose
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaModalBackdrop
  viewPath={`${viewPath}/TysiaModalBackdrop`}
 dangerouslyBypassFocusLock={dangerouslyBypassFocusLock}
>
{childProps => (
<div
  data-testid="TysiaModal.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-1kaJKF': dtColorsWhite,'--bblr-2-1kaJKF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-3-1kaJKF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-4-1kaJKF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-5-1kaJKF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--h-6-1kaJKF': typeof height === 'number' ? `${height}px` : height,'--mw-7-1kaJKF': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--w-8-1kaJKF': size === "large" ? "740px" : size === "medium" ? "540px" : size === "small" ? "360px" : typeof width === 'number' ? `${width}px` : width}}
 className={`views-block TysiaModalShadow ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 onClose={onClose}
>
{children}
</Children>
</div>
)}
</TysiaModalBackdrop>
</React.Fragment>)
}